var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_59",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_icon",
    "data-name": "add icon",
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -9)",
    filter: "url(#Ellipse_59)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59-2",
    "data-name": "Ellipse 59",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(9 9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243",
    transform: "translate(-274.355 -310.354)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_347",
    "data-name": "Line 347",
    y2: 14,
    transform: "translate(291.354 320.354)",
    fill: "none",
    stroke: "#2d335d",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_348",
    "data-name": "Line 348",
    y2: 13.709,
    transform: "translate(298.209 327.354) rotate(90)",
    fill: "none",
    stroke: "#2d335d",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRound);
export default __webpack_public_path__ + "static/media/add-round.e2fc5f2d6e156ed1a5172ecfcc88c5c5.svg";
export { ForwardRef as ReactComponent };